<form #form="ngForm" [formGroup]="formGroup" *ngIf="formGroup">
    <div class="brands _pb-7 _border-b _border-transparency-black-5">
        <div class="_flex _flex-row _flex-wrap _items-center _justify-between _my-5">
            <div class="_h4">Managing Brands</div>
            <div class="_flex _items-center"> 
                <div class="_flex _items-center _relative _mr-4 sm-max:_hidden">
                    <input 
                    class="_input-squared _h-form-field-slim _w-text-input _px-2" 
                    type="text" 
                    placeholder="Search managing brands"
                    [(value)]="brandsSearchTerm" 
                    (input)="searchBrands($event.target)">
                    <i class="fa-light fa-magnifying-glass _text-md _absolute _right-2"></i>
                </div>
                <div class="_link" (click)="clearFilters('brandIds'); brandsSearchTerm = ''">
                    <span class="_text-sm">Clear all </span>
                    <i class="fa-light fa-arrows-rotate _text-md"></i>
                </div>
            </div>
        </div>

        <div class="_inline-block _mb-2 _pb-2 _border-b">
            <label class="_chip-selectable">
                <input 
                    class="_checkbox"
                    type="checkbox"
                    [disabled]="allBrandIdsActive && !selectedBrandIdsStored.length"
                    [checked]="!selectedBrandIds.length || allBrandIdsActive"
                    (click)="toggleSelectAll('brandIds')">
                <span class="label _text-sm" tabindex="0">
                    All managing brands
                </span>
            </label>    
        </div>

        <app-expandable-content-container 
            previewSize="123px"
            [toggleButtonLabels]="brandExpandButtonLabels">
            <div class="_flex _flex-wrap _gap-2 _p-nudge-1">
                <label 
                    *ngFor="let brand of brands; let index = index" 
                    class="filter-radio-container _chip-selectable-checkbox"
                    [ngClass]="!brandsSearchTerm || brandsSearchResults.indexOf(brand.name) > -1 ? '_block' : '_hidden'"
                    formArrayName="brandIds">
                    <input 
                        [formControlName]="index"
                        class="_checkbox"
                        type="checkbox" 
                        id="brand-{{index}}">
                    <span class="label _text-sm" tabindex="0">
                        <span *ngIf="brand.logoUrl" class="_mr-2 _rounded _overflow-hidden">       
                            <app-operator-logo 
                                [width]="38" 
                                [height]="25" 
                                [operator]="{
                                    name: brand.name,
                                    logoUrl: brand.logoUrl
                                }">
                            </app-operator-logo>
                        </span>
                        {{brand.name}}
                    </span>
                </label>
                <div 
                    *ngIf="brandsSearchTerm && !brandsSearchResults.length" 
                    class="_mx-auto _text-sm _text-primary-1-tint-50">
                        No managing brands found
                    </div>
            </div>
        </app-expandable-content-container>
    </div>

    <div class="property-styles _pb-7 _border-b _border-transparency-black-5">
        <div class="_flex _flex-row _items-center _justify-between _my-5">
            <div class="_h4">Property Style</div>
            <div class="_link" (click)="clearFilters('propertyStyles')">
                <span class="_text-sm">Clear all </span>
                <i class="fa-light fa-arrows-rotate _text-md"></i>
            </div>
        </div>

        <div class="_inline-block _mb-2 _pb-2 _border-b">
            <label class="_chip-selectable">
                <input 
                    class="_checkbox"
                    type="checkbox"
                    [disabled]="allPropertyStylesActive && !selectedPropertyStylesStored.length"
                    [checked]="!selectedPropertyStyles.length || allPropertyStylesActive"
                    (click)="toggleSelectAll('propertyStyles')">
                <span class="label _text-sm" tabindex="0">
                    All property styles
                </span>
            </label>    
        </div>

        <div class="_flex _flex-wrap _gap-2">
            <label *ngFor="let style of propertyStyles; let index = index" class="_chip-selectable-checkbox" formArrayName="propertyStyles">
                <input 
                    [formControlName]="index"
                    [value]="style"
                    class="_checkbox"
                    type="checkbox">
                <span class="label _text-sm" tabindex="0">
                    {{ style | enumtitlecase }}
                </span>
            </label> 
        </div>
    </div>

    <div class="minimum-stay _pb-7 _border-b _border-transparency-black-5">
        <div class="_flex _flex-row _items-center _justify-between _my-5">
            <div class="_h4">Allows short stays</div>
            <div class="_link" (click)="resetMinStayFilter()">
                <span class="_text-sm">Clear all </span>
                <i class="fa-light fa-arrows-rotate _text-md"></i>
            </div>
        </div>

        <div class="_flex _flex-wrap _gap-2">
            <label *ngFor="let button of minStayFilterButtonsData; let index = index" class="_chip-selectable">
                <input 
                    formControlName="minStay"
                    [value]="button.value"
                    [checked]="index === 0"
                    class="_checkbox"
                    type="radio"
                    name="minStay">
                <span class="label _text-sm" tabindex="0">
                    {{ button.label }}
                </span>
            </label> 
        </div>
    </div>

    <div class="key-amenities _pb-7 _border-b _border-transparency-black-5">
        <div class="_flex _flex-row _items-center _justify-between _my-5">
            <div class="_h4">Key Amenities</div>
            <div class="_flex _items-center"> 
                <div class="_flex _items-center _relative _mr-4 sm-max:_hidden">
                    <input 
                        class="_input-squared _h-form-field-slim _w-text-input _px-2" 
                        type="text" 
                        placeholder="Search amenities"
                        [(value)]="amenitiesSearchTerm" 
                        (input)="searchAmenities($event.target)">
                        <i class="fa-light fa-magnifying-glass _text-md _absolute _right-2"></i>
                </div>
                <div class="_link" (click)="clearFilters('keyAmenityIds'); amenitiesSearchTerm = ''">
                    <span class="_text-sm">Clear all </span>
                    <i class="fa-light fa-arrows-rotate _text-md"></i>
                </div>
            </div>
        </div>
        <div class="_grid  _grid-cols-1 sm:_grid-cols-2 _gap-2">
            <span class="_hidden _show-next-sibling-span-element"></span>
            <ng-container *ngFor="let keyAmenity of amenitiesData.keyAmenities; let index = index">
                <div 
                    *ngIf="!amenitiesSearchTerm || amenitiesSearchResults.indexOf(keyAmenity.name) > -1"
                    class="_flex _items-center" 
                    formArrayName="keyAmenityIds">
                    <input 
                        [formControlName]="index"
                        id="key-{{keyAmenity.amenityId}}"
                        class="_checkbox _mr-2"
                        type="checkbox">
                    <label class="label _text-md _cursor-pointer" for="key-{{keyAmenity.amenityId}}">
                        {{ keyAmenity.name }}
                    </label>
                </div> 
            </ng-container>
            <span class="_hidden _text-sm _text-primary-1-tint-50">No key amenities found</span>
        </div>
    </div>

    <div class="other-amenities _pb-7">
        <div class="_flex _flex-row _items-center _justify-between _my-5">
            <div class="_h4">Other Amenities</div>
            <div class="_link" (click)="clearFilters('otherAmenityIds'); amenitiesSearchTerm = ''">
                <span class="_text-sm">Clear all </span>
                <i class="fa-light fa-arrows-rotate _text-md"></i>
            </div>
        </div>
        <div>
            <div *ngFor="let otherAmenitySection of amenitiesData.otherAmenities" formArrayName="otherAmenityIds">
                <div class="_h5 _mt-4 _mb-3">{{otherAmenitySection.name}}</div>
                <div class="_grid _grid-cols-1 sm:_grid-cols-2 _gap-2">
                    <span class="_hidden _show-next-sibling-span-element"></span>
                    <ng-container *ngFor="let otherAmenity of otherAmenitySection.amenities">
                        <div 
                            *ngIf="!amenitiesSearchTerm || amenitiesSearchResults.indexOf(otherAmenity.name) > -1" 
                            class="_flex _items-center">
                            <input 
                                [formControlName]="otherAmenity.index"
                                id="other-{{otherAmenity.amenityId}}"
                                class="_checkbox _mr-2"
                                type="checkbox">
                            <label class="label _text-md _cursor-pointer" for="other-{{otherAmenity.amenityId}}">
                                {{ otherAmenity.name }}
                            </label>
                        </div>
                    </ng-container>
                    <span class="_hidden _text-sm _text-primary-1-tint-50">No {{otherAmenitySection.name.toLowerCase()}} amenities found</span>
                </div>
            </div>  
        </div>
    </div>
</form>
